$(document).ready(function() {
  var $contactUsForm = $("form#subscribe-form");
  $contactUsForm.ajaxForm();
  $contactUsForm.on("submit", function(e) {
    e.preventDefault();
    $contactUsForm.data("jqxhr").done(function(data) {
      $contactUsForm.trigger("reset");
      const $tooltip = $($contactUsForm.data("target"));
      $tooltip.removeClass("is-danger");
      $tooltip.addClass("active");
      $tooltip.text("Thanks for your interest!");
    });
    $contactUsForm.data("jqxhr").catch(function(error) {
      const $tooltip = $($contactUsForm.data("target"));
      $tooltip.addClass("is-danger");
      $tooltip.addClass("active");
      $tooltip.text("Oops, there was an error with your submission");
    });
  });
});
